import { ApiContext } from '../../types'
import getCurrentBearerToken from '@/api_client/api/authentication/getCurrentBearerToken'

// old
export default async function addPayoutItemsByConsignmentId(
  { client, config }: ApiContext,
  payoutId,
  consignmentId,
  isIncludeQuantity = false,
): Promise<boolean> {
  try {
    const token = await getCurrentBearerToken({
      client,
      config,
    })

    const result = await client.payouts.addPayoutItemsByConsignmentId(
      { bearerToken: token },
      payoutId,
      consignmentId,
      isIncludeQuantity,
    )

    if (result.isSuccess()) {
      // const payload = result.success()
      // return deserializePayoutItem(payload.data, payload.included, [config], 0)
      return true
    } else {
      throw result.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
